import type { Contact } from '@/api/types/contacts';
import { SideCard, Tag } from '@/components/ui';

/**
 * Third detail-page column (≥1440px only — hidden via .detail-notes in
 * tokens.css): read-only list of the contact's Notes. Editing stays in the
 * main column's Notes form section; this is a glanceable reading pane.
 */
export function ContactNotesAside({ contact }: { contact: Contact | undefined }) {
  const notes = [...(contact?.notes ?? [])].reverse(); // newest first

  return (
    <aside className="detail-notes">
      <SideCard title={notes.length > 0 ? `Notes (${notes.length})` : 'Notes'}>
        {notes.length === 0 && (
          <div style={{ color: 'var(--text-4)', fontSize: 12.5 }}>No notes</div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {notes.map((n, i) => (
            <div
              key={i}
              style={{
                padding: 10,
                borderRadius: 8,
                background: 'var(--surface-2)',
                border: '1px solid var(--divider)',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                {n.category && <Tag tone="teal">{n.category}</Tag>}
                <span style={{ fontSize: 11, color: 'var(--text-3)' }}>
                  {n.addedBy}
                  {n.addedAt && ` · ${new Date(n.addedAt).toLocaleDateString()}`}
                </span>
              </div>
              <div style={{ fontSize: 12.5, color: 'var(--text-1)', whiteSpace: 'pre-wrap' }}>
                {n.text}
              </div>
            </div>
          ))}
        </div>
      </SideCard>
    </aside>
  );
}
